import { Spinner } from '@chakra-ui/react';
import Layout from '../components/layouts/main';
import MintKey from '../components/mint';
import useContractMintData from '../hooks/useContractMintData';
import useMintCount from '../hooks/useMintCount';

// Запрос на неограниченное кол-во кошельков
// Сохранение в csv
// Расширенная статистика бейджев 

const MintPage = () => {
	const {
		tierData,
		currentTierData,
		imageURIData,
		isTier1Success,
		isTier2Success,
		isTier3Success
	} = useContractMintData();
	const { data, loading } = useMintCount();
	return (
		<Layout>
			{isTier1Success && isTier2Success && isTier3Success && !loading &&
				<MintKey
					currentTier={currentTierData ? currentTierData[0].toString() : <Spinner />}
					tierData={tierData}
					imageURI={imageURIData}
					savedEventCount={data}
				/>
			}
		</Layout>
	);
};

export default MintPage;
